import {fUSD, WSOL} from "@/api/token_swap/constants";
import {web3} from "@project-serum/anchor";

/**
 * Recursively sanitizes an object to make it safe for JSON serialization
 * - Converts BigInt to Number
 * - Converts PublicKey to string
 * - Works on nested objects and arrays
 * @param {Object} obj - Object to sanitize
 * @returns {Object} - Sanitized copy of the object
 */
function sanitizeForSerialization(obj) {
	if (obj === null || obj === undefined) {
		return obj;
	}

	// Handle primitive types
	if (typeof obj !== 'object') {
		// Convert BigInt to Number
		if (typeof obj === 'bigint') {
			return Number(obj);
		}
		return obj;
	}

	// Handle PublicKey objects
	if (obj instanceof web3.PublicKey) {
		return obj.toString();
	}

	// Handle Date objects
	if (obj instanceof Date) {
		return obj.toISOString();
	}

	// Handle arrays
	if (Array.isArray(obj)) {
		return obj.map(item => sanitizeForSerialization(item));
	}

	// Handle objects
	const sanitized = {};
	for (const key in obj) {
		if (Object.prototype.hasOwnProperty.call(obj, key)) {
			sanitized[key] = sanitizeForSerialization(obj[key]);
		}
	}
	return sanitized;
}

export default {
	namespaced: true,
	state: () => ({
		loading: false,
		tokenAAmount: 0,
		tokenBAmount: 0, //Mainly only used for liquidity page
		tokenA: localStorage.getItem("swap:default_token_a") ? JSON.parse(localStorage.getItem("swap:default_token_a")) : {
			address: WSOL, decimals: 9, name: "Fogo", symbol: "FOGO", verified: true,
			programID: "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
		},
		tokenB: localStorage.getItem("swap:default_token_b") ? JSON.parse(localStorage.getItem("swap:default_token_b")) : {
			address: fUSD, decimals: 5, name: "fUSD", symbol: "fUSD", verified: true,
			image: "https://fogo.fluxbeam.xyz/images/token/fusd.svg",
			programID: "TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb"
		},
	}),
	mutations: {
		setTokenA(state, token) {
			// Use the sanitize function to make the token serializable
			const tokenToStore = sanitizeForSerialization(token);

			state.tokenA = tokenToStore;
			localStorage.setItem("swap:default_token_a", JSON.stringify(tokenToStore));
		},
		setTokenB(state, token) {
			// Use the sanitize function to make the token serializable
			const tokenToStore = sanitizeForSerialization(token);

			state.tokenB = tokenToStore;
			localStorage.setItem("swap:default_token_b", JSON.stringify(tokenToStore));
		},
		setTokenAAmount(state, amount) {
			state.tokenAAmount = amount;
		},
		setTokenBAmount(state, amount) {
			state.tokenBAmount = amount;
		},
		set_loading(state, loading) {
			state.loading = loading;
		},
		clear(state) {
			//TODO
			state.loading = false
		},
	},
	actions: {
		setTokenA({dispatch, commit}, token) {
			commit('setTokenA', token)
			if (token.decimals === 0)
				dispatch('getTokenADecimals')
		},
		setTokenB({dispatch, commit}, token) {
			commit('setTokenB', token)
			if (token.decimals === 0)
				dispatch('getTokenBDecimals')
		},

		async getTokenADecimals({state, commit, rootState}) {
			const resp = await rootState.solana.client.getParsedAccountInfo(new web3.PublicKey(state.tokenA.address), "processed")

			// Create a deep copy to avoid modifying the original state
			const token = {...state.tokenA}
			token.decimals = resp?.data?.parsed?.info?.decimals || 0

			commit('setTokenA', token)
		},

		async getTokenBDecimals({state, commit, rootState}) {
			const resp = await rootState.solana.client.getParsedAccountInfo(new web3.PublicKey(state.tokenB.address), "processed")

			// Create a deep copy to avoid modifying the original state
			const token = {...state.tokenB} // Fixed: was using tokenA incorrectly
			token.decimals = resp?.data?.parsed?.info?.decimals || 0

			commit('setTokenB', token) // Fixed: was using setTokenA incorrectly
		},
	}
}
